<template>
  <div class="overflow-auto h-100">
    <div class="item-list" v-if="hasItems">
      <list-item
          v-for="item in items"
          :row="item"
          :key="item.id"
          class="item-list__item"
      ></list-item>
    </div>
    <div v-else class="h-100 d-flex align-items-center justify-content-center text-muted-light font-weight-bold">
      Empty
    </div>
  </div>
</template>

<script>
import ListItem from './permission-list-item';

export default {
  components: {
    ListItem,
  },

  props: {
    items: Array,
  },

  computed: {
    /**
     * @return {boolean}
     */
    hasItems() {
      return _.size(this.items) > 0;
    },
  },
}
</script>
